<template>
  <div class="cj-toast" v-show="animating" :class="{ success }">
    <div class="container">
      <div class="glow" />
      <div class="word" />

      <div class="sparkles sparkles1">
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
      </div>

      <div class="sparkles sparkles2">
        <div class="sparkle" />
        <div class="sparkle" />
        <div class="sparkle" />
      </div>
    </div>
  </div>
</template>

<script>
import { map } from 'ramda'
import { tween, styler, easing, stagger } from 'popmotion'

import { shuffle } from '@/util/function'
import { setTimeout } from 'timers'

export default {
  name: 'CJToast',

  props: {
    success: {
      type: Boolean,
      required: true,
    },
  },

  mounted () {
    const sparkles = this.$el.querySelectorAll('.sparkle')
    const sparklesStylers = shuffle(map(styler, sparkles))

    stagger(map(sparkle => tween({
      from: { opacity: 0.3 },
      to: { opacity: 0.8 },
      ease: easing.backOut,
      flip: Infinity,
      duration: 500,
    }), sparkles), 50)
      .start(vs => vs.forEach((v, idx) => sparklesStylers[idx].set(v)))
  },

  data () {
    return {
      animating: false,
    }
  },

  methods: {
    show () {
      const glowStyler = styler(this.$el.querySelector('.glow'))
      const selfStyler = styler(this.$el.childNodes[0])

      this.animating = true

      tween({
        from: { opacity: 0 },
        to: { opacity: 0.4 },
        ease: easing.reversed(easing.createBackIn(5)),
        duration: process.env.NODE_ENV === 'development' ? 100 : 1000,
      })
        .start(v => glowStyler.set(v))

      tween({
        from: { scale: 0.2, opacity: 0 },
        to: { scale: 1, opacity: 1 },
        ease: easing.backOut,
        duration: process.env.NODE_ENV === 'development' ? 100 : 1000,
      }).start({
        update: v => selfStyler.set(v),
        complete: () => setTimeout(
          () => this.hide(),
          process.env.NODE_ENV === 'development' ? 300 : 1000
        ),
      })
    },

    hide () {
      const selfStyler = styler(this.$el.childNodes[0])

      tween({
        from: { scale: 1, opacity: 1 },
        to: { scale: 1.2, opacity: 0 },
        ease: easing.easeInOut,
        duration: process.env.NODE_ENV === 'development' ? 100 : 1000,
      })
        .start({
          update: v => selfStyler.set(v),
          complete: () => {
            this.animating = false
            this.$emit('hide')
          },
        })
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-toast
    overflow: visible

    > .container
      position: relative

      > .glow
      > .word
      > .sparkles
      > .sparkles > .sparkle
        position: absolute

      > .sparkles > .sparkle
        opacity: 0.8

      > .sparkles1 > .sparkle
        &:nth-child(1)
          top: 91px
          left: 5px

        &:nth-child(2)
          top: 115px
          left: 56px

        &:nth-child(3)
          top: 112px
          left: 60px

        &:nth-child(4)
          top: 109px
          left: 53px

        &:nth-child(5)
          top: 74px
          left: 284px

        &:nth-child(6)
          top: 72px
          left: 279px

        &:nth-child(7)
          top: 13px
          left: 266px

        &:nth-child(8)
          top: 16px
          left: 217px

        &:nth-child(9)
          top: 20px
          left: 215px

        &:nth-child(10)
          top: 39px
          left: 105px

        &:nth-child(11)
          top: 46px
          left: 111px

        &:nth-child(12)
          top: 47px
          left: 104px

      > .sparkles2 > .sparkle
        &:nth-child(1)
          top: -11px
          left: 278px

        &:nth-child(2)
          top: 88px
          left: 155px
          transform: rotate(185deg)

        &:nth-child(3)
          top: 36px
          left: -8px
          transform: rotate(-36deg)

      > .glow
        top: -43px
        left: -42px
        opacity: 0.4

    &.success > .container
      > .sparkles1 > .sparkle
        &:nth-child(1)
          top: 106px
          left: 3px

        &:nth-child(2)
          top: 116px
          left: 56px

        &:nth-child(3)
          top: 113px
          left: 60px

        &:nth-child(4)
          top: 110px
          left: 53px

        &:nth-child(5)
          top: 79px
          left: 274px

        &:nth-child(6)
          top: 77px
          left: 270px

        &:nth-child(7)
          top: 14px
          left: 259px

        &:nth-child(8)
          top: 18px
          left: 208px

        &:nth-child(9)
          top: 22px
          left: 206px

        &:nth-child(10)
          top: 35px
          left: 83px

        &:nth-child(11)
          top: 42px
          left: 89px

        &:nth-child(12)
          top: 43px
          left: 82px

      > .sparkles2 > .sparkle
        &:nth-child(1)
          top: -9px
          left: 265px

        &:nth-child(2)
          top: 100px
          left: 114px

        &:nth-child(3)
          top: 34px
          left: 1px
</style>
